import {IssuesLoadingSkeleton} from '@github-ui/issues-loading-skeleton'
import {Heading} from '@primer/react'

import {BUTTON_LABELS} from '../../../constants/buttons'
import {TEST_IDS} from '../../../constants/test-ids'
import styles from './HeaderLoading.module.css'

export const HeaderLoading = () => {
  return (
    <div data-testid={TEST_IDS.headerLoading} className={styles.HeaderLoadingContainer}>
      <div className={styles.headingContainer}>
        <Heading as="h1" className={styles.Heading}>
          {BUTTON_LABELS.issues}
        </Heading>
      </div>
      <IssuesLoadingSkeleton height="xl" width="150px" />
    </div>
  )
}

try{ HeaderLoading.displayName ||= 'HeaderLoading' } catch {}